import { ApiError } from '@/types/ApiError';
import { clearAuthCookies } from '@/lib/utils/jwt';

export function handleApiError(
  error: unknown,
  toast: { error: (msg: string) => void },
  fallbackMsg = 'An error occurred',
  options?: {
    onSessionExpired?: () => void;
  }
) {
  const err = error as ApiError;
  
  // Handle session expiration (401 Unauthorized)
  if (err?.response?.status === 401) {
    clearAuthCookies();
    toast.error('Your session has expired. Please sign in again.');
    if (options?.onSessionExpired) {
      options.onSessionExpired();
    }
    return;
  }
  
  const apiMessage = err?.response?.data?.message;
  if (Array.isArray(apiMessage)) {
    apiMessage.forEach((msg: string) => toast.error(msg));
  } else if (typeof apiMessage === 'string') {
    toast.error(apiMessage);
  } else if (err?.message) {
    toast.error(err.message);
  } else {
    toast.error(fallbackMsg);
  }
}